import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';
import { getIsReseller } from 'store/publisher/selectors';
import { getDealType } from './getDealType';

export const getHasProgrammaticCampaignRequiredFields = createSelector(
  [
    (state: Store) => state.dealManagement.commonDeal.dealName,
    (state: Store) => state.dealManagement.commonDeal.cpm,
    getDealType,
    (state: Store) => state.dealManagement.commonDeal.advertiser,
    (state: Store) => state.dealManagement.commonDeal.brand,
    (state: Store) => state.dealManagement.commonDeal.productCategory,
    (state: Store) => state.dealManagement.programmatic.dsp,
    (state: Store) => state.dealManagement.isCpmCampaignLevel,
    (state: Store) => state.dealManagement.commonDeal.currentLine.cpm,
    getIsReseller,
  ],
  (dealName, cpm, dealType, advertiser, brand, productCategory, dsp, isCpmCampaignLevel, lineCpm, isReseller) =>
    !!(
      dealName &&
      dealType &&
      (isCpmCampaignLevel ? cpm : lineCpm) &&
      dsp?.code &&
      (!isReseller ? advertiser?.code : true) &&
      (!isReseller ? brand?.code : true) &&
      (!isReseller ? productCategory?.code : true)
    ),
);
